import { SvgIcon, SvgIconProps } from '@material-ui/core';
import React, { FC } from 'react';

export const DuplicateApplicant: FC<SvgIconProps> = props => (
  <SvgIcon {...props}>
    <svg height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 6C7.65685 6 9 4.65685 9 3C9 1.34315 7.65685 0 6 0C4.34315 0 3 1.34315 3 3C3 4.65685 4.34315 6 6 6Z" />
      <path d="M12 11.254C12 10.348 11.6467 9.4855 11.016 8.923C10.052 8.062 8.38 7 6 7C3.62 7 1.948 8.062 0.984 8.923C0.353333 9.4855 0 10.348 0 11.254V13H12V11.254Z" />
      <circle cx="11.5" cy="11.5" fill="#E51F58" r="4.5" />
      <rect fill="white" height="1" transform="rotate(-90 11 12)" width="3" x="11" y="12" />
      <rect fill="white" height="1" transform="rotate(-90 11 14)" width="1" x="11" y="14" />
    </svg>
  </SvgIcon>
);
